export default "__VITE_ASSET__8752fcc7__"